import { render } from "./InviteRegister.vue?vue&type=template&id=5e876497"
import script from "./InviteRegister.vue?vue&type=script&lang=js"
export * from "./InviteRegister.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./InviteRegister.vue?vue&type=style&index=0&id=5e876497&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__